import { Head } from "@inertiajs/react"
import AdminLayout from "../../../layouts/AdminLayout"
import TopicForm from "./Form"

type Props = {
  topic: {
    id: number | null
    name: string
    summary: string | null
    jp: string | null
    slug: string | null
    banner_url: string | null
  }
  errors?: Record<string, string[]>
}

export default function EditTopic({ topic, errors }: Props) {
  return (
    <AdminLayout title={`Edit ${topic.name}`}>
      <Head title={`Edit ${topic.name}`} />
      <TopicForm topic={topic} errors={errors} />
    </AdminLayout>
  )
}
